import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './EnviarMensagem.css'

const EnviarMensagem = () => {
    const [membros, setMembros] = useState([])
    const [dados, setDados] = useState({data: new Date().toLocaleString(), usuarioFonte: localStorage.nomeE})

    useEffect(() => {
        const url = `/api/userEtica/getMembros/`
        axios(url)
            .then(res => {
                setMembros(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    const updateField = (e) => {
        const { name, value } = e.target
        setDados(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const save = () => {
        const url = '/api/mensagem/envioEtica'
        axios.post(url, dados)
            .then(res => {
                alert(res.data)
                window.location = `/etica`
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            });
    }

    return (
        <React.Fragment>
            <div className="labelBuscaPed">
                <i className="bi bi-envelope iconeBuscaPed"></i>
                MENSAGEM
            </div>
            <div className="caixaMensagemEnvio">
                <div className="labelSuporte">
                    NOVA MENSAGEM
                </div>
                <label className="destinatarioEnvio">Destinatário</label>
                <select name="usuarioDestino" className="userDestinoEnvio"
                    onChange={e => updateField(e)} >
                    <option value=""></option>
                    {selectMembros()}
                </select>
                <span className='destinatarioEnvio'>Mensagem</span>
                <textarea className='textareaMensagemEnvio'
                    name='texto'
                    onChange={e => updateField(e)}></textarea>
            </div>
            <button className="botaoNPed" onClick={() => save()}>ENVIAR</button>
        </React.Fragment>
    )

    function selectMembros() {
        let select = []
        membros.map(x => {
            select.push(
                <option key={x.nome} value={x.nome}>{x.nome}</option>
            )
        })
        return select
    }
}

export default EnviarMensagem